import { Button, Modal, Space } from 'antd'
import { FC } from 'react'

type SaveGuardModalProps = {
  open: boolean
  isSaving: boolean
  saveDisabled?: boolean
  saveDisabledReason?: string
  onSaveAndContinue: () => void
  onDiscardAndContinue: () => void
  onCancel: () => void
}

export const SaveGuardModal: FC<SaveGuardModalProps> = ({
  open,
  isSaving,
  saveDisabled = false,
  saveDisabledReason,
  onSaveAndContinue,
  onDiscardAndContinue,
  onCancel,
}) => (
  <Modal
    title='Unsaved Changes'
    open={open}
    onCancel={onCancel}
    footer={
      <Space>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onDiscardAndContinue}>Discard & Continue</Button>
        <Button
          type='primary'
          loading={isSaving}
          disabled={saveDisabled}
          title={saveDisabled ? saveDisabledReason : undefined}
          onClick={onSaveAndContinue}>
          Save & Continue
        </Button>
      </Space>
    }>
    {saveDisabled && saveDisabledReason
      ? saveDisabledReason
      : 'You have unsaved changes. Would you like to save before continuing?'}
  </Modal>
)
